import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieStorage implements Storage {
readonly length: number;
[key: string]: any;
prefix = '';
lifetime = '30';

constructor() {

}

clear(): void {
  let cookies = document.cookie.split(';');
  cookies = cookies.filter(value => {
    return value.startsWith(this.prefix) || value.startsWith(` ${this.prefix}`);
  });
  for (let i = 0; i < cookies.length; i++) {
    const key = cookies[i].split('=');
    document.cookie = `${key[0]}=; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  }
}

setItem(key: string, value: any): void {
  this.setItemCookie(this.prefix + key, value, parseFloat(this.lifetime));
}

key(index: number): string | null {
  return this[index];
}

getItem(key: string): string | null {
  const item = this.getItemCookie(this.prefix + key);
  return item === '' ? null : item;
}

removeItem(key: string): void {
  this.removeCookie(key);
}

private removeCookie(cName: string) {
  const date = new Date();
  date.setTime(date.getTime() - (1000 * 60 * 60 * 24));
  window.document.cookie = `${cName}=; expires=${date.toUTCString()}`;
}

private getItemCookie(cName: string): string {
  const name = cName + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

private setItemCookie(cName: string, cValue: string, expires?: number): void {
  let cookieStr = `${cName}=${cValue};`;
  if (expires) {
      const expireTime = this.setExpiration(expires);
      cookieStr += 'expires=' + expireTime + ';';
  }

  document.cookie = cookieStr;
}

private setExpiration(cookieLife: number): string {
  const today = new Date();
  const expr = new Date(today.getTime() + cookieLife * 60 * 1000);
  return expr.toUTCString();
}
}
